<template>
  <section
    class="lg:w-6/12 bg-gray-800 shadow-2xl rounded-lg overflow-hidden relative text-white"
  >
    <div id="header-buttons" class="py-3 px-4 flex relative">
      <div class="rounded-full w-3 h-3 bg-red-500 mr-2"></div>
      <div class="rounded-full w-3 h-3 bg-yellow-500 mr-2"></div>
      <div class="rounded-full w-3 h-3 bg-green-500"></div>

      <ClipboardCopy :container="codeContainer" />
    </div>
    <article class="py-4 px-4 text-sm overflow-auto">
      <pre ref="codeContainer">{{ code }}</pre>
    </article>
    <aside v-show="details" class="mx-4 py-4 border-t-slate-400 border-t-[1px]">
      <template v-if="Array.isArray(details)">
        <ul>
          <li class="my-2" v-for="(detail, index) in details" :key="index">
            {{ detail.value }}
          </li>
        </ul>
      </template>
      <template v-else-if="typeof details === 'object'">
        <ul>
          <li v-for="(value, key) in details" :key="key" class="my-2">
            {{ key }}: "{{ value }}"
          </li>
        </ul>
      </template>
      <template v-else>
        {{ details }}
      </template>
    </aside>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ClipboardCopy from "./ClipboardCopy.vue";

defineProps<{
  code: string;
  details?: string | Record<string, any>;
}>();

const codeContainer = ref<HTMLElement>();
</script>